import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const SupFooter = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: 4,
        backgroundColor: "#26816C",
        color: "white",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        borderTop: "1px solid rgba(255,255,255,0.1)"
      }}
    >
      <div>
        {" "}
        <Link to="/">
          <Button sx={{ color: "white" }}>Home</Button>
        </Link>{" "}
        <Link to="/Branches">
          <Button sx={{ color: "white" }}>Branches</Button>{" "}
        </Link>{" "}
        <Link to="/Contact">
          <Button sx={{ color: "white" }}>Contact</Button>{" "}
        </Link>{" "}
        <Link to="/Reviews">
          <Button sx={{ color: "white" }}>Reviews</Button>
        </Link>{" "}
      </div>
      <Typography variant="body2">
        Food Ex © {new Date().getFullYear()}
      </Typography>
    </Box>
  );
};

export default SupFooter;
